import { Chip } from "@mui/material";
import { useTranslation } from "react-i18next";

import { GqlPlannerV2AreaStatus } from "~/__generated__";

type Props = {
    plannerAreaStatus: GqlPlannerV2AreaStatus;
};

const STATUS_META: Record<
    GqlPlannerV2AreaStatus,
    {
        color: "secondary" | "success" | "error";
        labelKey: string;
    }
> = {
    [GqlPlannerV2AreaStatus.Confirmed]: {
        color: "success",
        labelKey: "PlannerAreaStatusChip.confirmed",
    },
    [GqlPlannerV2AreaStatus.OnHold]: {
        color: "secondary",
        labelKey: "PlannerAreaStatusChip.onHold",
    },
    [GqlPlannerV2AreaStatus.Cancelled]: {
        color: "error",
        labelKey: "PlannerAreaStatusChip.cancelled",
    },
};

export default function PlannerAreaStatusChip({ plannerAreaStatus }: Props) {
    const { t } = useTranslation("shared");
    const current = STATUS_META[plannerAreaStatus];

    return <Chip label={t(current.labelKey)} color={current.color} size="small" />;
}
